import script from "./AddEquiType.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEquiType.vue?vue&type=script&setup=true&lang=js"

import "./AddEquiType.vue?vue&type=style&index=0&id=47634948&lang=scss"

const __exports__ = script;

export default __exports__